export type Transaction = {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: string;
  torderId: number;
  totalAmount: number;
  checkOutAmount: number;
  payload: Payload;
  paymentReferenceId: string;
  remark: string;
  description: string;
  currency: Currency;
  exchangeRateHistory: ExchangeRateHistoryList;
  user: User;
  paymentTransactionList: PaymentTransactionList[];
};

interface PaymentTransactionList {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  amount: number;
  paymentReferenceId: string;
  payload: Payload;
  status: string;
}

interface Currency {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  displayName: string;
  currencyCode: string;
  fromCurrencyExchangeRateList: FromCurrencyExchangeRateList[];
  toCurrencyExchangeRateList: FromCurrencyExchangeRateList[];
  paymentOrderList: string[];
}

interface FromCurrencyExchangeRateList {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  amount: number;
  fromCurrency: string;
  toCurrency: string;
  user: User;
  exchangeRateHistoryList: ExchangeRateHistoryList[];
}

interface ExchangeRateHistoryList {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  amount: number;
  paymentOrderList: string[];
}

interface User {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: string;
  name: string;
  email: string;
  username: string;
  password: string;
  phoneNumber: string;
}

interface Payload {
  additionalProp1: AdditionalProp1;
  additionalProp2: AdditionalProp1;
  additionalProp3: AdditionalProp1;
}

interface AdditionalProp1 {}

export const TRANSACTION_ENDPOINT = "/admin/transaction";

export const transactionsApi = {};
